import React, { useEffect, useRef, useState } from "react";
import MyIcon from "../../Images/av-logo.svg";
import "./Navbartwo.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import {
  FaChevronDown,
  FaChevronUp,
  FaUserTie,
  FaClipboardList,
  FaMoneyCheckAlt,
  FaUsers,
  FaChartLine,
  FaHeartbeat,
  FaBalanceScale,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaBrain,
  FaUserFriends,
  FaTools,
  FaPiggyBank,
  FaGlobeAmericas,
  FaBookOpen,
  FaPeopleCarry,
  
} from "react-icons/fa";
import { Divider } from "primereact/divider";
import { Sidebar } from "primereact/sidebar";

function Navbar() {
  const dropdownRef = useRef(null);
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenN, setIsOpenN] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 901);
  const [expandedPanel, setExpandedPanel] = useState(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const shouldAddClass = location.pathname === "/Contact";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 901);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const openDropdown = () => setIsOpen(true);
  const closeDropdown = () => setIsOpen(false);

  const handleClickOutside = (evt) => {
    if (dropdownRef.current && !dropdownRef.current.contains(evt.target)) {
      closeDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const togglePanel = (panelKey) => {
    setExpandedPanel((prevKey) => (prevKey === panelKey ? null : panelKey));
  };

  return (
    <nav>
      <Link to="/" onClick={() => setIsSidebarVisible(false)}>
        <img className="my-icon" src={MyIcon} alt="Logo" />
      </Link>

      <ul ref={dropdownRef} style={{ display: isMobile ? "none" : "flex" }}>
        <li className="nav-items">
          <NavLink
            exact="true"
            to="/"
            activeClassName="active"
            onClick={() => setIsSidebarVisible(false)}>
            Home
          </NavLink>
        </li>

        <li
          className="dropdownparent "
          onMouseEnter={openDropdown}
          onMouseLeave={closeDropdown}>
          <div style={{ cursor: "pointer" }}>
            Services {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {isOpen && (
            <div className="dropdown-content multi-column">
              <ColumnSection
                header="HR Services"
                items={hrServices}
                // onLinkClick={() => setIsSidebarVisible(false)}
                onLinkClick={() => {
                  if (!isMobile) closeDropdown(); // close only in desktop
                  setIsSidebarVisible(false); // always hide sidebar if open
                }}
              />
              <Divider layout="vertical" />
              <ColumnSection
                header="Coaching & Facilitation"
                items={coaching}
                // onLinkClick={() => setIsSidebarVisible(false)}
                onLinkClick={() => {
                  if (!isMobile) closeDropdown(); // close only in desktop
                  setIsSidebarVisible(false); // always hide sidebar if open
                }}
              />
              <Divider layout="vertical" />
              <ColumnSection
                header="EduSupport"
                items={eduSupport}
                // onLinkClick={() => setIsSidebarVisible(false)}
                onLinkClick={() => {
                  if (!isMobile) closeDropdown(); // close only in desktop
                  setIsSidebarVisible(false); // always hide sidebar if open
                }}
              />
            </div>
          )}
        </li>

        <li className="nav-items">
          <NavLink to="/aboutus" onClick={() => setIsSidebarVisible(false)}>
            About Us
          </NavLink>
        </li>
      </ul>

      <div>
        <NavLink
          to="/contactus"
          className={`contactBtn ${shouldAddClass ? "border-right" : ""}`}
          onClick={() => setIsSidebarVisible(false)}>
          Contact Us
        </NavLink>
      </div>

      {/* Hamburger + Sidebar for mobile */}
      {isMobile && (
        <>
          <div className="hamburger">
            <RxHamburgerMenu onClick={() => setIsSidebarVisible(true)} />
          </div>

          <Sidebar
            visible={isSidebarVisible}
            onHide={() => {
              setIsSidebarVisible(false);
              setExpandedPanel(null);
            }}
            position="right"
            style={{ width: "300px" }}>
            <MobileLink
              to="/"
              text="Home"
              onClick={() => setIsSidebarVisible(false)}
            />

            <CollapsibleSection
              title="HR Services"
              panelKey="hr"
              expandedPanel={expandedPanel}
              togglePanel={togglePanel}
              items={hrServices}
              onLinkClick={() => {
                setIsSidebarVisible(false);
                setExpandedPanel(null); // collapse panel after link click
              }}
            />

            <CollapsibleSection
              title="Coaching & Facilitation"
              panelKey="coaching"
              expandedPanel={expandedPanel}
              togglePanel={togglePanel}
              items={coaching}
              onLinkClick={() => {
                setIsSidebarVisible(false);
                setExpandedPanel(null); // collapse panel after link click
              }}
            />

            <CollapsibleSection
              title="EduSupport"
              panelKey="edu"
              expandedPanel={expandedPanel}
              togglePanel={togglePanel}
              items={eduSupport}
              onLinkClick={() => {
                setIsSidebarVisible(false);
                setExpandedPanel(null); // collapse panel after link click
              }}
            />

            <MobileLink
              to="/aboutus"
              text="About Us"
              onClick={() => setIsSidebarVisible(false)}
            />
            <MobileLink
              to="/contactus"
              text="Contact Us"
              onClick={() => setIsSidebarVisible(false)}
            />
          </Sidebar>
        </>
      )}
    </nav>
  );
}

// ---------- Components ---------- //

const ColumnSection = ({ header, items, isActive, onLinkClick }) => (
  <div className="column">
    <div className="column-header">
      {/* <div className={`column-header ${isActive ? "active-heading" : ""}`}> */}
      <strong>{header}</strong>
      <Divider />
    </div>
    {items.map(({ to, icon, text }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          isActive ? "dd-links active" : "dd-links"
        }
        onClick={onLinkClick}>
        {React.cloneElement(icon, { style: { marginRight: "8px" } })} {text}
      </NavLink>
    ))}
  </div>
);


const PanelLinks = ({ items, onLinkClick }) => (
  <>
    {items.map(({ to, icon, text }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          isActive ? "dd-links active" : "dd-links"
        }
        onClick={() => {
          onLinkClick?.();
          if (window.innerWidth < 900) window.scrollTo(0, 0);
        }}>
        {React.cloneElement(icon, { style: { marginRight: "8px" } })} {text}
      </NavLink>
    ))}
  </>
);

const MobileLink = ({ to, text, onClick }) => (
  <div className="mobile-link-wrapper">
    <NavLink to={to} className="dd-links" onClick={onClick}>
      <b>{text}</b>
    </NavLink>
  </div>
);

const CollapsibleSection = ({
  title,
  panelKey,
  expandedPanel,
  togglePanel,
  items,
  onLinkClick,
}) => (
  <div className="collapsible-section">
    <div className="collapsible-header" onClick={() => togglePanel(panelKey)}>
      <b>{title}</b>{" "}
      {expandedPanel === panelKey ? <FaChevronUp /> : <FaChevronDown />}
    </div>
    {expandedPanel === panelKey && (
      <div className="collapsible-content">
        <PanelLinks items={items} onLinkClick={onLinkClick} />
      </div>
    )}
  </div>
);

// ---------- Data ---------- //

const hrServices = [
  { to: "/ExecutiveHiring", icon: <FaUserTie />, text: "Executive Hiring" },
  {
    to: "/PreAndPostOnboarding",
    icon: <FaClipboardList />,
    text: "Pre & Post Onboarding",
  },
  { to: "/Payroll", icon: <FaMoneyCheckAlt />, text: "Payroll Management" },
  { to: "/EmployeeEngagement", icon: <FaUsers />, text: "Employee Engagement" },
  {
    to: "/PerformanceManagement",
    icon: <FaChartLine />,
    text: "Performance Management",
  },
  {
    to: "/EmployeeBenefitsAndWellnessPortal",
    icon: <FaHeartbeat />,
    text: "Employee Benefits & Wellness",
  },
  {
    to: "/StatutoryAndCompliance",
    icon: <FaBalanceScale />,
    text: "Statutory & Compliance",
  },
];

const coaching = [
  {
    to: "/ExecutiveCoaching",
    icon: <FaChalkboardTeacher />,
    text: "Executive Coaching",
  },
  {
    to: "/CareerTransition",
    icon: <FaUserGraduate />,
    text: "Career Transition",
  },

  {
    to: "/Teambuilding",
    icon: <FaPeopleCarry/>,
    text: "Team Building",
  },
];

const eduSupport = [
  {
    to: "/AIpsychotest",
    icon: <FaBrain />,
    text: "AI Powered Psychometric Tests",
  },
  {
    to: "/PersonalCounselling",
    icon: <FaUserFriends />,
    text: "Personal Counselling",
  },
  { to: "/SkillBuilding", icon: <FaTools />, text: "Skill Building" },
  {
    to: "/FinancialPlanning",
    icon: <FaPiggyBank />,
    text: "Financial Planning",
  },
  { to: "/StudyAbroad", icon: <FaGlobeAmericas />, text: "Study Abroad" },
  { to: "/CareerLibrary", icon: <FaBookOpen />, text: "Career Library" },
];

export default Navbar;
